/* ================================================================
   LIVEFAST ECOSYSTEM — Global Feature JS
   Loaded on every page (after theme.js). Reads window.LF_CONFIG.
   Features: nav MORE dropdown · studio FAQ accordion ·
             studio contact form · FM visualizer stagger
================================================================ */

(function () {
  'use strict';

  function safeRun(label, fn) {
    try { fn(); } catch (e) { console.warn('[LF:' + label + ']', e); }
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ONE-TIME INIT GUARD — prevents double-binding on duplicate include */
    if (window.__lfEcosystemBound) return;
    window.__lfEcosystemBound = true;

    var CFG = window.LF_CONFIG || {};

    /* ════════════════════════════════════════════════════════
       GLOBAL NAV — MORE DROPDOWN
    ════════════════════════════════════════════════════════ */
    safeRun('nav more dropdown', function () {
      var btn = document.getElementById('nav-more-btn');
      var dropdown = document.getElementById('nav-more-dropdown');
      if (!btn || !dropdown) return;

      function close() {
        btn.classList.remove('open');
        dropdown.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
      function open() {
        btn.classList.add('open');
        dropdown.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dropdown.classList.contains('open')) close(); else open();
      });
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target) && e.target !== btn) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });

    /* ════════════════════════════════════════════════════════
       STUDIO — Smooth FAQ (details/summary enhancement)
       Native <details> already works; this just adds a small
       scroll-into-view on open for UX.
    ════════════════════════════════════════════════════════ */
    safeRun('studio faq', function () {
      var items = document.querySelectorAll('.st-faq-item');
      if (!items.length) return;
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (this.open) {
            /* close siblings */
            items.forEach(function (sibling) {
              if (sibling !== item && sibling.open) sibling.open = false;
            });
            /* gentle scroll */
            setTimeout(function () {
              item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 50);
          }
        });
      });
    });

    /* ════════════════════════════════════════════════════════
       STUDIO — Contact form submission notice
       (placeholder — no backend yet)
    ════════════════════════════════════════════════════════ */
    safeRun('studio form', function () {
      var form = document.getElementById('st-contact-form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (!btn) return;
        var orig = btn.textContent;
        btn.textContent = 'MESSAGE SENT ✓';
        btn.disabled = true;
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled    = false;
          form.reset();
        }, 3500);
      });
    });

    /* ════════════════════════════════════════════════════════
       FM PAGE — stagger vis bar animations via CSS var(--i)
    ════════════════════════════════════════════════════════ */
    safeRun('fm vis stagger', function () {
      var bars = document.querySelectorAll('.fm-bar');
      bars.forEach(function (bar, i) {
        bar.style.setProperty('--i', i);
        bar.style.animationDelay = (i * 0.035) + 's';
      });
      /* also stagger widget bars */
      var wBars = document.querySelectorAll('.fm-w-vis span');
      wBars.forEach(function (b, i) {
        b.style.animationDelay = (i * 0.08) + 's';
        b.style.setProperty('--wh', (Math.random() * 60 + 20) + '%');
      });
    });

  });

}());
